// @flow

import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Grid, makeStyles, Typography} from '@material-ui/core';

import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';

import type {Theme} from '@material-ui/core';

type Props = {
  open: boolean,
  handleClose: () => void,
  onConfirm: () => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 380,
    maxWidth: '100%',
    padding: theme.spacing(5, 2, 1, 2),
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
  },
  grayText: {
    fontWeight: 400,
    textAlign: 'center',
    fontSize: 16,
    color: colors.grey800,
  },
  actionGrid: {
    margin: theme.spacing(2, 0),
  },
}));

export default function ConsentUpdateSettingModal(props: Props) {
  const {open, handleClose, onConfirm} = props;
  const classes = useStyles();
  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title} align="center" gutterBottom>
          ¿Estás seguro que deseas anular tu renovación con puntos TiendaDa?
        </Typography>

        <Typography className={classes.grayText} gutterBottom>
          *Contáctate con soporte para realizar la devolución de tus puntos.
        </Typography>

        <Grid container spacing={2} className={classes.actionGrid}>
          <Grid item xs={4}>
            <CustomButton fullWidth variant="outlined" onClick={handleClose}>
              No
            </CustomButton>
          </Grid>
          <Grid item xs={8}>
            <CustomButton fullWidth variant="contained" onClick={onConfirm}>
              Continuar
            </CustomButton>
          </Grid>
        </Grid>
      </div>
    </CustomModal>
  );
}

ConsentUpdateSettingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
